export default __webpack_public_path__ + "static/media/Division_04.d7e56201.png";